module.exports = __webpack_public_path__ + "img/pic4.438c7a8c.png";